import styled from "styled-components";

export const UpdatePasswordWrapper = styled.section`
  padding-top: 26px;
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    width: 80%;
    margin: 0 auto;
  }
`;
export const Header = styled.header`
  margin-bottom: 32px;
`;
export const Title = styled.h1`
  font-family: "Plus Jakarta Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 0.5rem;
  line-height: 24px;
  color: #18181b;
`;
export const Description = styled.p`
  font-family: "Plus Jakarta Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #71717a;
`;

export const FormContainer = styled.div`
  // width: 50%;
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    width: 100%;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 0 10px;
  }
`;
export const Form = styled.form`
  width: 70%;
  @media screen and (max-width: 1230px) {
    width: 100%;
  }
  @media screen and (min-width: 435px) and (max-width: 960px) {
    width: 100%;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;
export const MainFieldsContainer = styled.div`
  display: grid;
  /* grid-template-columns: 1fr 1fr; */
  grid-template-columns: 1fr;
  @media screen and (min-width: 436px) and (max-width: 960px) {
  }
  @media screen and (max-width: 786px) {
    grid-template-columns: 1fr;
  }
`;
export const FieldContainer = styled.div`
  width: 70%;
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  @media screen and (min-width: 900px) and (max-width: 1024px) {
    width: 50%;
  }
  @media screen and (min-width: 436px) and (max-width: 900px) {
    width: 100%;
  }
`;
export const FieldLabelContainer = styled.div`
  width: 50%;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  display: flex;
  align-items: center;
  height: 54px;
`;
export const FieldLabel = styled.label`
  width: 100%;
  color: #482952;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.01em;
`;
export const FieldInputContainer = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 30px;
  @media screen and (min-width: 436px) and (max-width: 960px) {
    width: 100%;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;
export const RequiredIcon = styled.img`
  position: absolute;
  top: 23px;
  left: 18px;
`;
export const FieldInput = styled.input`
  width: 100%;
  height: 54px;
  border: 1px solid #d4d4d8;
  border-radius: 7px;
  padding: 17px 16px 17px 18px;
  text-indent: 10px;
  outline: none;
  :disabled {
    color: ${(props) => (props.disabled ? "#482952" : "#000")};
  }
  /* @media screen and (max-width: 768px) {
    width: 100%;
  } */
  @media screen and (min-width: 436px) and (max-width: 960px) {
    width: 100%;
  }
`;
export const EyeIcon = styled.img`
  position: absolute;
  top: 18px;
  right: 9px;
  cursor: pointer;
`;
export const FieldError = styled.span`
  /* error color */
  color: #ff0000;
`;
export const UpdateButtonContainer = styled.div`
  margin: 16px 0;
  width: 50%;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;
export const UpdateButton = styled.button`
  height: 55px;
  background: #3d0052;
  background-color: ${(props) => (props.disabled ? "#3d2450" : "#3d0052")};
  border-radius: 5px;
  color: #fff;
  font-family: "Plus Jakarta Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  width: 50%;
  border: none;
  cursor: pointer;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};

  &:disabled {
    opacity: 0.5;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  }
`;

// password requirements component
export const PasswordRequirements = styled.div``;
export const PasswordRequirementsTitle = styled.h3``;
export const PasswordRequirementsList = styled.ul``;
export const PasswordRequirementsListItem = styled.li``;
export const PasswordRequirementsListItemIcon = styled.img``;
